module.exports = __webpack_public_path__ + "bf1.no2.a7c05eb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/bf1.no2.jpg
// module id = y9kM
// module chunks = 0